import React from 'react'
import {Pill} from '../../../core/components/pill/Pill'
import './searchFilters.css'

const numToShow = 3

class SearchFilters extends React.PureComponent {
  constructor(props) {
    super(props)
    let shouldBeExpanded = false
    this.state = {
      isExpanded: shouldBeExpanded
    }
    this.expandPills = this.expandPills.bind(this)
  }
  componentDidUpdate() {
    let shouldBeExpanded = this.state.isExpanded
    if (!shouldBeExpanded) {
      for (let i = 0; i < this.props.pills.length; i++) {
        if (this.props.pills[i].active && i >= numToShow) {
          shouldBeExpanded = true
          break
        }
      }
      this.setState({
        isExpanded: shouldBeExpanded
      })
    }
  }
  expandPills() {
    this.setState({isExpanded: true})
  }

  render() {
    const {pills: propPills, applyFilter} = this.props
    const {isExpanded} = this.state
    const pills = isExpanded ? propPills : propPills.slice(0,numToShow)
    return (
      <div className='searchfilters'>
        <span className='searchfilters__title'>Filters</span>
        <ul className='searchfilters__list'>
          {
            pills.map((p)=>{
              // TODO: Look at how to handle filters for multiple languages
              return (
                <Pill className='searchfilters__pill'
                  key={p.filter}
                  color={p.color}
                  active={p.active}
                  onClick={()=>(applyFilter(p.filter))}>
                  {p.filter}
                </Pill>
              )
            })
          }
          {
            !isExpanded
              ? <Pill className='searchfilters__pill'
                active={false}
                color='algebra-2'
                onClick={()=>this.expandPills()} >
                ...
              </Pill>
              : null
          }
        </ul>
      </div>
    )
  }
}
export default SearchFilters



// WEBPACK FOOTER //
// ./src/domains/search/components/SearchFilters.js